export default __webpack_public_path__ + "static/media/1113.83387573.png";